export const EXPAND_TOGGLE_ANIMATION_TIMEOUT_MILLISECONDS = 300;
